<div fxLayoutAlign="center center" fxLayout="column" fxFill>
  <h1>OOPS...</h1>
  <h2>404</h2>
  <p>Job not found</p>
</div>
